import React from 'react';
import styled from 'styled-components';
import SharedLocationForm from '../forms/LocationForm';
import DateNavigator from '../shared/DateNavigator';
import AyanamsaSelector from '../forms/AyanamsaSelector';
import SiddhantaSelector from './SiddhantaSelector';
import useLocale from '../hooks/useLocale';

const Card = styled.div`
  background: ${p => p.theme.colors.surface};
  border-radius: ${p => p.theme.radius.lg}px;
  box-shadow: ${p => p.theme.shadow.card};
  padding: 24px;
  margin-bottom: ${p => p.theme.spacing[5]}px;
`;

const FormRow = styled.div`
  display: flex;
  gap: ${p => p.theme.spacing[4]}px;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    flex-direction: column;
  }
`;

const LocationCol = styled.div`
  flex: 0 0 35%;
  min-width: 220px;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

const DateCol = styled.div`
  flex: 0 0 30%;
  min-width: 170px;
  display: flex;
  align-items: center;
  min-height: 48px;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

const AyanamsaCol = styled.div`
  flex: 0 0 17.5%;
  min-width: 130px;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

const SiddhantaCol = styled.div`
  flex: 0 0 17.5%;
  min-width: 130px;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

const PanchangamForm = ({
  place, lat, lon, timezone,
  date, ayanamsa, siddhanta,
  onPlaceChange, onDateChange, onAyanamsaChange, onSiddhantaChange,
  ayanamsaDisabled = false,
  loading = false, lang = 'en',
}) => {
  const tSiddhanta = useLocale(lang, 'siddhanta');

  return (
    <Card>
      <FormRow>
        <LocationCol>
          <SharedLocationForm
            placeValue={place}
            lat={lat}
            lon={lon}
            timezone={timezone}
            onPlaceChange={onPlaceChange}
            onSubmit={null}
            submitLabel={null}
            loading={loading}
            pageName="todayPanchangam"
            lang={lang}
            showDate={false}
          />
        </LocationCol>
        <DateCol>
          <DateNavigator
            value={date}
            onChange={onDateChange}
            disabled={loading}
            lang={lang}
          />
        </DateCol>
        <AyanamsaCol>
          <AyanamsaSelector
            value={ayanamsa}
            onChange={onAyanamsaChange}
            disabled={loading || ayanamsaDisabled}
            disabledReason={ayanamsaDisabled ? tSiddhanta?.ayanamsaDisabledTooltip : undefined}
            lang={lang}
          />
        </AyanamsaCol>
        <SiddhantaCol>
          <SiddhantaSelector
            value={siddhanta}
            onChange={onSiddhantaChange}
            disabled={loading}
            lang={lang}
          />
        </SiddhantaCol>
      </FormRow>
    </Card>
  );
};

export default PanchangamForm;
